/** Operasyon / Tur PDF Düzenleme ekranının metinleri. */
export const TUR_PDF = {
  title: 'Tur PDF düzenleme',
  eyebrow: 'OPERASYON',
  intro: 'Tedarikçi PDF’indeki hatalı metinleri kayıtlı profille düzeltin. Özgün belge korunur.',
  belgeTurleri: { TUR: 'Tur', OTEL: 'Otel', UCUS: 'Uçuş', DIGER: 'Diğer' } as Record<string, string>,

  belgeBolumu: 'Belge seçimi',
  belgeAra: 'Belge adıyla ara',
  belgeAraIpucu: 'Dosya adının bir bölümünü yazın',
  belgeYok: 'Düzenlenebilir PDF belgesi bulunamadı. Yeni bir PDF yükleyebilirsiniz.',
  belgeSec: 'Kaynak belge',
  belgeSayfalama: 'Kaynak belge sayfaları',
  kaynakSuresiDoldu: 'Kaynak belgenin süresi doldu. Kayıtlı sürümler indirilebilir; yeniden işlemek için kaynak PDF’i yükleyin.',
  onceki: 'Önceki',
  sonraki: 'Sonraki',
  sayfaOzeti: (sayfa: number, sayfalar: number, toplam: number) => `${toplam} belge · Sayfa ${sayfa}/${sayfalar}`,
  surumSayisi: (n: number) => (n === 0 ? 'Henüz düzenlenmiş sürüm yok' : `${n} düzenlenmiş sürüm`),
  yeniPdf: 'Yeni kaynak PDF yükle',
  yeniPdfIpucu: 'Yüklenen dosya belge deposuna kaydedilir; özgün kalır.',
  yukleniyor: 'Yükleniyor…',
  yuklendi: (ad: string) => `${ad} belge deposuna yüklendi ve seçildi.`,
  parola: 'PDF parolası',
  parolaIpucu: 'Yalnız parolalı PDF’lerde gerekir. Kaydedilmez, kayıtlara yazılmaz.',

  profilBolumu: 'Profil seçimi',
  turSuzgeci: 'Belge türü',
  tumTurler: 'Tüm türler',
  profilSec: 'Düzeltme profili',
  profilSecilmedi: 'Profil seçin',
  profilYok: 'Bu türde kayıtlı profil yok.',
  profilYokYonetici: 'Bu türde kayıtlı profil yok. Aşağıdan yeni profil oluşturabilirsiniz.',
  tedarikci: 'Tedarikçi',
  tedarikciYok: 'Belirtilmemiş',
  profilSurumu: (n: number) => `Profil sürümü ${n}`,

  kuralBolumu: 'Kural önizlemesi',
  kuralAciklama: 'Her satır belgedeki aranan metni yeni metinle değiştirir. Yeni metin boşsa aranan metin silinir.',
  aranan: 'Aranan metin',
  yeniMetin: 'Yeni metin',
  silinir: '(silinir)',
  kuralYok: 'Profilde kural yok.',
  kuralSayisi: (n: number) => `${n} kural`,

  ekBolumu: 'Ek sayfa',
  ekYok: 'Bu profilde ek sayfa yok. Çıktıda yalnız metin değişir, sayfa sayısı korunur.',
  ekDosya: 'Kayıtlı ek PDF',
  ekSayfaSayisi: (n: number | null) => (n === null ? 'Sayfa sayısı bilinmiyor' : `${n} sayfa`),
  kaynakSayfa: 'Kaynak sayfa (ek PDF içinden)',
  kaynakSayfaIpucu: 'Ek PDF’in kaçıncı sayfası alınacak.',
  cikti: 'Çıktıdaki sıra (sonuç PDF’inde)',
  ciktiIpucu: 'Alınan sayfa sonuç PDF’inde kaçıncı sırada olacak. 1 başa, sayfa sayısı + 1 sona ekler.',
  ozetSira: (kaynak: number, sira: number) => `Ek PDF’in ${kaynak}. sayfası, çıktıda ${sira}. sırada yer alır.`,
  maxKb: 'Sayfa başı üst sınır (KB)',
  maxKbIpucu: '1 KB = 1024 bayt. Çıktı boyutu en çok çıktıdaki sayfa sayısı x bu değerdir (varsayılan 500 KB); ek PDF de yüklenirken bu sınıra göre optimize edilir.',
  maxKbOzet: (sayfa: number, kb: number, sinirMb: string) => `Örnek: ${sayfa} sayfalık çıktıda sınır ${sinirMb} (${sayfa} x ${kb} KB).`,
  ekOptimizeUyari: 'Yüklenen ek PDF sayfa başı sınıra göre optimize edilir. Özgün dosya saklanmaz, yalnız optimize hali kalıcıdır.',
  ekKaldir: 'Kayıtlı eki kaldır',
  ekKaldirUyari: 'Bu işlem anında ve kalıcıdır: ek PDF dosyası ve depo kaydı silinir. Kurallar korunur.',
  ekKaldirOnay: 'Eki kalıcı olarak sil',
  ekKaldirVazgec: 'Vazgeç',
  ekKaldirildi: 'Ek kalıcı olarak silindi. Kurallar korundu; sonraki çıktılarda ek sayfa olmayacak.',
  ekOnizle: 'Ek PDF’i aç',

  topluBaslik: 'Toplu PDF düzenleme',
  topluAciklama: 'Seçili profilin kuralları ve kayıtlı ek PDF’i her dosyaya uygulanır. Kaynaklar CRM’e yüklenir ve 15 gün sonra silinir. Düzenlenmiş çıktıları ZIP olarak indirin.',
  topluDosyalar: 'Birden fazla kaynak PDF seç',
  topluDosyaSec: 'İşlemek için kaynak PDF dosyalarını seçin.',
  topluSinirlar: 'En çok 20 PDF, dosya başına 10 MiB, toplam 200 MiB. Yeni seçim mevcut toplu sonuçları temizler.',
  topluAdetSiniri: 'Tek seferde en çok 20 PDF seçebilirsiniz.',
  topluBoyutSiniri: 'Her PDF en çok 10 MiB olabilir.',
  topluToplamSiniri: 'Seçilen dosyaların toplamı en çok 200 MiB olabilir.',
  topluPdfGerekli: 'Yalnız PDF dosyaları seçin.',
  topluCiktiSiniri: 'Çıktıların toplamı 200 MiB sınırını aşıyor. Daha küçük gruplar halinde işleyin.',
  topluParola: 'Toplu işlem için ortak PDF parolası',
  topluParolaIpucu: 'Varsa aynı parola bütün kaynaklara uygulanır. Hatalı parolayı düzeltip başarısız dosyaları tekrar deneyebilirsiniz; başarılı dosyalar korunur.',
  topluProfilDegisti: 'Profil sürümü değişti. Sonuçları indirebilirsiniz. Güncel profille işlemek için dosyaları yeniden seçin.',
  topluYuklemeBelirsiz: 'Kaynak yüklenemedi veya yanıt alınamadı. Aynı dosyayı tekrar yüklemeden önce kaynak belge listesini kontrol edin.',
  topluZipHatasi: 'ZIP hazırlanamadı. Başarılı sonuçlar korunuyor; yeniden indirmeyi deneyin.',
  topluIlerleme: (sira: number, toplam: number) => `${sira}/${toplam} dosya işleniyor…`,
  topluSonuc: (basarili: number, toplam: number) => `${toplam} dosyadan ${basarili} başarıyla işlendi.`,
  topluProfil: (ad: string, surum: number) => `Toplu işlem profili: ${ad} · sürüm ${surum}`,
  topluDurum: { bekliyor: 'Bekliyor', yukleniyor: 'Yükleniyor', isleniyor: 'İşleniyor', basarili: 'Hazır', hatali: 'Başarısız' },
  topluIsle: 'Seçili profille hepsini işle',
  topluTekrar: 'Başarısız işlemleri yeniden dene',
  topluZip: (n: number) => `ZIP indir (${n} PDF)`,

  islemBolumu: 'İşle',
  onizle: 'Önizle',
  indir: 'İndir',
  yeniSurum: 'Yeni sürüm olarak kaydet',
  isleniyor: 'İşleniyor…',
  kaydediliyor: 'Kaydediliyor…',
  onizlemeBaslik: 'Düzenlenmiş PDF önizlemesi',
  eslesme: (n: number, sayfa: number) => `${n} eşleşme, çıktı ${sayfa} sayfa. Henüz kaydedilmedi.`,
  indirildi: (ad: string) => `${ad} indirildi.`,
  kaydedildi: (ad: string, no: number) => `${ad} kaynağın ${no}. sürümü olarak kaydedildi. Özgün belge değişmedi.`,
  zatenKayitli: (no: number) => `Bu istek daha önce kaydedilmişti (${no}. sürüm). Yeni sürüm oluşturulmadı.`,
  engelBelge: 'Önce bir kaynak belge seçin.',
  engelProfil: 'Önce bir profil seçin.',
  engelKuralYok: 'Profilde kural yok.',
  surumlerBaslik: 'Bu belgenin düzenlenmiş sürümleri',
  surumNo: (n: number) => `Sürüm ${n}`,
  surumYok: 'Henüz düzenlenmiş sürüm yok.',

  yonetimBolumu: 'Profil yönetimi',
  yonetimAciklama: 'Kural, ek sayfa ve sıra değişiklikleri sürüm numarasını artırır. Başka ekranda değişmiş profil kaydedilmez.',
  yeniProfil: 'Yeni profil',
  duzenle: 'Profili düzenle',
  ad: 'Profil adı',
  belgeTuru: 'Belge türü',
  kuralEkle: 'Kural ekle',
  kuralSil: 'Kuralı kaldır',
  kaydet: 'Profili kaydet',
  vazgec: 'Vazgeç',
  profilKaydedildi: (n: number) => `Profil kaydedildi (sürüm ${n}).`,
  profilOlusturuldu: 'Profil oluşturuldu.',
  ekYukle: 'Ek PDF yükle veya değiştir',
  ekYuklendi: 'Ek PDF kaydedildi. Eski ek kalıcı olarak silindi.',
  ekYuklenirken: 'Ek yükleniyor…',
  yenile: 'Profilleri yenile',
  yenilendi: 'Profil listesi yenilendi.',
  yonetimYok: 'Profil tanımlama yetkiniz yok. Değişiklik için Yönetici ile görüşün.',
  maksKural: 'En çok 50 kural, her metin en çok 2000 karakter.',
} as const;
